module.exports = __webpack_public_path__ + "img/small_coin.def5a765.svg";